/** Classic through next model year; mirrored by includes/vehicle_year.php. */
export const MIN_VEHICLE_YEAR = 1886;
export const maxVehicleYear = () => new Date().getFullYear() + 1;
export const vehicleYearOptions = () => Array.from(
  { length: maxVehicleYear() - MIN_VEHICLE_YEAR + 1 }, (_, i) => maxVehicleYear() - i
);
